module.exports = __webpack_public_path__ + "img/quinoa-veggie-bake.72af2db8.jpg";